import { html, ViewTemplate, when } from '@microsoft/fast-element';
import type { TileCard } from './tile-card';
import {getHtmlIconByName} from '../../../styles';
import {ICONS} from "../../../utils";

export const TileCardTemplate: ViewTemplate<TileCard> = html`
  <div class="rectangule ${(x) => (x.inline ? 'inline' : '')}">
    <div class="title">
      ${(x) => x.title}
      ${when(
        (x) => x.tooltip,
        html`
          <span id=${(x) => x?.title}>
            ${() => getHtmlIconByName({name: ICONS.CIRCLED_INFO, slot: 'start', width: '12px', height: '12px'})}
          </span>
          <zero-tooltip anchor=${(x) => x?.title} position="top">${(x) => x.tooltip}</zero-tooltip>
        `,
      )}
    </div>
    <div class="value">
      <slot></slot>
    </div>
  </div>
`;
